module.exports = __webpack_public_path__ + "img/logo.65f15dab.svg";